export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";